export const getHorseType = ({ damStatus, sireStatus }) => {
    if (damStatus) { return 'dam'; }
    if (sireStatus) { return 'sire'; }
    return 'horse';
};

export const hasProgeny = profile => getHorseType(profile) !== 'horse';

export const isWeatherbysMobile = ({ weatherbysUid, isMobile }) => weatherbysUid && !isMobile;

export const shouldShowReplayButton = (videoDetail) => {
    if (!videoDetail || !videoDetail.videoProvider) {
        return false;
    }

    const { videoProvider, finishRaceUid, ptvAssetId } = videoDetail;

    if (videoProvider === 'RUK') {
        return Boolean(ptvAssetId);
    }

    return Boolean(finishRaceUid);
};



// WEBPACK FOOTER //
// ./src/js/utils/horse.js